import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { DeviceService } from '../../device.service';

@Component({
	selector: 'app-power-study-reports',
	templateUrl: './power-study-reports.component.html',
})
export class PowerStudyReportsComponent implements OnInit, OnChanges {
	constructor(
		public deviceService: DeviceService
	) { }

	@Input() siteUtilizationSettings: any;
	@Input() studyInfo: any;
	@Input() device: any;
	@Input() currentSite: any;
	@Input() deviceConfig: any;
	@Input() deviceType: number;
	@Input() tooltips: any = {};

	studyFilters: { startDate: Date; endDate: Date; workingDays: string } = { startDate: null, endDate: null, workingDays: '' };
	showSocChart: boolean = false;
	powerStudyReportData: any;
	selectedDays: string = 'allDays';

	ngOnInit(): void {
		// Initialization logic if needed
	}

	get studyStartedToday(): boolean {
		return !!(this.studyInfo?.id && moment.unix(this.studyInfo.start_study_time).isSame(moment(), 'day'));
	}

	onStudyFiltersChanged(filters: { startDate: Date; endDate: Date; workingDays: string }) {
		this.studyFilters = filters;
		this.selectedDays = filters.workingDays;
		this.getPsReportData();
	}

	ngOnChanges(changes: SimpleChanges) {
		for (const change in changes) {
			if (!changes[change].firstChange)
				this.getPsReportData();
		}	
	}


	getPsReportData() {
		if (this.studyStartedToday)
			return this.powerStudyReportData = null;

		const zoneDiff = new Date().getTimezoneOffset() * -1 * 60 * 1000;
		let fromDate: any	= new Date(new Date(this.studyFilters.startDate).getTime() + zoneDiff);
		let toDate: any	= new Date(new Date(this.studyFilters.endDate).getTime() + zoneDiff);
		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		this.deviceService.getPsReportData(this.device.mac_address,[this.deviceType], fromDate, toDate, {studyId: this.studyInfo.id, siteId: this.studyInfo.site_id}).subscribe((res: any) => { 
			this.powerStudyReportData = res.data;
		}); 
	}
}
